module.exports = __webpack_public_path__ + "eed0394d67db31f8431b61901df87e75.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/group/RePanda_Logo.png
// module id = 118
// module chunks = 0